module.exports = __webpack_public_path__ + "img/shoot_00022.f1a2f6cb.png";